var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReportDetailDown = function SvgReportDetailDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M16 30C8.269 30 2 23.731 2 16S8.269 2 16 2s14 6.269 14 14-6.269 14-14 14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E44134",
    d: "M21.563 12.656h-1.466a1 1 0 0 0-.81.413L16 17.613l-3.287-4.544a1 1 0 0 0-.81-.413h-1.466c-.203 0-.321.231-.203.397l5.563 7.688c.1.137.303.137.403 0l5.563-7.688a.249.249 0 0 0-.2-.397"
  }))));
};
export default SvgReportDetailDown;